import { MbUserAddressesEffects } from './mb-user-addresses.effect'

export const effects: any[] = [
  MbUserAddressesEffects
]

export * from './mb-user-addresses.effect'
